import { Component } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatDialogClose } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-delete-key-dialog',
  templateUrl: './delete-key-dialog.component.html',
  styleUrls: ['./delete-key-dialog.component.scss'],
  imports: [MatButton, MatDialogClose, TranslateModule],
})
export class DeleteKeyDialogComponent {}
